import type moment from 'moment';
import { createContext, useContext } from 'react';
import { assert } from 'ts-essentials';

export type MomentInstance = typeof moment;

const MomentContext = createContext<MomentInstance | null>(null);

export const useMoment = () => {
  const value = useContext(MomentContext);

  assert(value, 'useMomentContext must be used within a MomentContextProvider');

  return value;
};

export default MomentContext;
